// extracted by mini-css-extract-plugin
export default {"wrapper":"xtuRtQH","title":"C5IiZn9"};